// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.information-container[data-v-18b57ac6] {\r\n  margin-bottom: 250px !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
